import { schema } from "normalizr";
import EventRecord from "records/event";

const EventSchema = new schema.Entity(
    "events",
    {},
    {
        idAttribute: "id",
    }
);

EventSchema.record = EventRecord;

export default EventSchema;
